import { DataTableSearch } from '@/components/ui/table/data-table-search';
import { useInquiryTableFilters } from './use-inquiry-table-filters';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { memo } from 'react';

function InquiryTableAction() {
  const { searchQuery, setSearchQuery, sort, setSort, status, setStatus, resetFilters, isAnyFilterActive } = useInquiryTableFilters();

  const sortingOptions = [
    { label: 'Newest', value: 'desc' },
    { label: 'Oldest', value: 'asc' },
  ];

  const statusOptions = [
    { label: 'All Status', value: 'all' },
    { label: 'Pending', value: 'pending' },
    { label: 'Resolved', value: 'resolved' }
  ];

  const handleSortingChange = (value: string) => {
    setSort(value);
  };

  const handleStatusChange = (value: string) => {
    setStatus(value === 'all' ? null : value);
  };

  return (
    <div className='flex flex-wrap items-center justify-between gap-4 px-5'>
      <DataTableSearch
        searchKey='inquiries'
        searchQuery={searchQuery || ''}
        setSearchQuery={setSearchQuery as any}
        setPage={async () => new URLSearchParams()} 
        className='bg-[#F7F7F7]'
      />

      <div className='flex items-center gap-4'>
        {/* Status Filter */}
        <div className='flex items-center gap-2'>
          <p className='font-grotesk text-text-primary'>Status</p>
          <Select
            onValueChange={handleStatusChange}
            value={status || 'all'}
          >
            <SelectTrigger className='w-[140px]'>
              <SelectValue placeholder='All Status' />
            </SelectTrigger>
            <SelectContent>
              {statusOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Sorting Select */}
        <div className='flex items-center gap-2'>
          <p className='font-grotesk text-text-primary'>Sort By</p>
          <Select
            onValueChange={handleSortingChange}
            value={sort || undefined}
          >
            <SelectTrigger className='w-[150px]'>
              <SelectValue placeholder='Select sorting' />
            </SelectTrigger>
            <SelectContent>
              {sortingOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Reset Filters Button */}
        {isAnyFilterActive && (
          <Button
            variant='outline'
            onClick={resetFilters}
          >
            Reset Filters
          </Button>
        )}
      </div>
    </div>
  );
}

export default memo(InquiryTableAction);